import { Outlet } from 'react-router';

import { AppTopBar } from '@/app/layout/AppTopBar';
import { DashboardSidebar } from '@/app/layout/DashboardSidebar';
import { UnlinkedSiteScopeNotice } from '@/app/layout/UnlinkedSiteScopeNotice';
import { paths } from '@/app/routes/paths';
import { WORKSPACE_PAGE_GRADIENT } from '@/app/layout/constants';
import { resolveDefaultHomePath } from '@/features/auth/lib/default-home-path';
import { isEmailVerified, shouldShowPostVerifyWelcome, useAuthStore } from '@/store';

export function DashboardLayout() {
  const user = useAuthStore((s) => s.user);
  const showSidebar = user ? isEmailVerified(user) && !shouldShowPostVerifyWelcome(user) : false;

  return (
    <div
      className="flex h-dvh max-h-dvh w-full flex-col overflow-hidden"
      style={{ backgroundImage: WORKSPACE_PAGE_GRADIENT }}
    >
      <AppTopBar
        userName={user?.fullName ?? ''}
        logoTo={user ? resolveDefaultHomePath(user) : paths.dashboard}
      />
      <main className="relative flex min-h-0 flex-1 overflow-hidden">
        {showSidebar ? <DashboardSidebar /> : null}
        <section className="relative z-0 flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto overflow-x-hidden">
          {showSidebar ? <UnlinkedSiteScopeNotice /> : null}
          <Outlet />
        </section>
      </main>
    </div>
  );
}
